export const stratClassOptions = [{ label: 'All', value: 'All' }];

export const viewOptions = [
  { label: 'Monthly', value: 'monthly' },
  { label: 'Quarterly', value: 'quarterly' },
];

export const monthOptions = [
  { label: 'January', value: 1 },
  { label: 'February', value: 2 },
  { label: 'March', value: 3 },
  { label: 'April', value: 4 },
  { label: 'May', value: 5 },
  { label: 'June', value: 6 },
  { label: 'July', value: 7 },
  { label: 'August', value: 8 },
  { label: 'September', value: 9 },
  { label: 'October', value: 10 },
  { label: 'November', value: 11 },
  { label: 'December', value: 12 },
];

export const quarterOptions = [
  { label: 'Quarter 1', value: 1 },
  { label: 'Quarter 2', value: 2 },
  { label: 'Quarter 3', value: 3 },
  { label: 'Quarter 4', value: 4 },
];

export const defaultForm = {
  strat: stratClassOptions[0],
  view: viewOptions[0],
  month: monthOptions[0],
  quarter: quarterOptions[0],
};
